import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  overflow-y: auto;
`;

export const CategoryContainer = styled.div`
  width: 90%;
  min-height: 44px;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  align-items: center;
  display: flex;
  position: relative;

  label {
    color: ${({ theme }) => theme.primary.purple};
    font-weight: 400;
    font-size: 14px;
    margin-left: 10px;
  }
  svg {
    position: absolute;
    right: 5px;
    cursor: pointer;
  }
`;
